import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { ajaxCall } from './axios'

const initialState = {
  agenda: {},
  agendaSearch: null,
  selectedEvent: null,
}

export const agendaSlice = createSlice({
  name: 'agenda',
  initialState,
  reducers: {
    updateAgenda: (state, action) => {
      state.agenda = action.payload
    },
    updateAgendaSearch: (state, action) => {
      state.agendaSearch = action.payload
    },
    updateSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload
    },
  },
})

export const { updateAgenda, updateAgendaSearch, updateSelectedEvent } = agendaSlice.actions

export const loadAgenda = createAsyncThunk('agenda/load', async (obj, thunkAPI) => {
  const { appConfig } = thunkAPI.getState().app

  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: appConfig.actions.agenda.get.path,
        method: 'get',
        params: obj.params,
      },
      success: (res) => {
        thunkAPI.dispatch(updateAgenda(res.data))

        const eventData = obj.updateEvent

        if (eventData) {
          thunkAPI.dispatch(updateSelectedEvent(eventData))
        }
      },
      error: () => {},
      activeLoading: false,
    })
  )
})

export const searchAgenda = createAsyncThunk('agenda/search', async (obj, thunkAPI) => {
  const { appConfig } = thunkAPI.getState().app

  const { agendaSearch } = thunkAPI.getState().agenda

  thunkAPI.dispatch(updateAgendaSearch(null))

  if (obj.preventNewSearch) {
    return
  }

  thunkAPI.dispatch(
    ajaxCall({
      config: {
        url: appConfig.actions.agenda.search.path,
        method: 'get',
        params: obj,
      },
      success: (res) => {
        const { previous } = obj

        const currentEvents = previous ? 'pastEvents' : 'futureEvents'

        const otherEvents = previous ? 'futureEvents' : 'pastEvents'

        const oldResults = obj.clear
          ? {
              futureEvents: [],
              pastEvents: [],
              hasMore: {
                futureEvents: true,
                pastEvents: true,
              },
            }
          : cloneDeep(agendaSearch)

        const newData = res.data

        newData[currentEvents] = newData.events.map((event, index) => {
          const toReturn = {
            ...event,
            __path: ['agendaData', 'events', index],
          }

          if (event.workers) {
            toReturn.workers = event.workers.map((worker, workerIndex) => ({
              ...worker,
              __path: ['agendaData', 'events', index, 'workers', workerIndex],
            }))
          }

          return toReturn
        })

        const firstArray = previous ? newData[currentEvents] : oldResults[currentEvents]

        const secondArray = previous ? oldResults[currentEvents] : newData[currentEvents]

        newData[currentEvents] = firstArray.concat(secondArray)

        newData[otherEvents] = oldResults[otherEvents]

        newData.hasMore = oldResults.hasMore

        newData.hasMore[currentEvents] = res.data.events.length === 100

        newData.from = newData.from || oldResults.from

        newData.to = newData.to || oldResults.to

        thunkAPI.dispatch(updateAgendaSearch(newData))
      },
      error: () => {},
      activeLoading: false,
    })
  )
})

export default agendaSlice.reducer
